<template>
  <div class="border">
    <v-col cols="12" v-if="loadingPreview">
      Image Preview Upload
      <button
        v-if="imagePreview.length > 0"
        class="btn btn-sm btn-danger"
        @click="cancelImagePreview"
      >
        <i class="fa fa-times"></i>
      </button>
      <input
        type="file"
        @change="onFilePreviewChange"
        multiple
        ref="inputPreview"
        style="display: none"
      />
      <button
        @click="$refs.inputPreview.click()"
        class="btn btn-sm btn-secondary"
      >
        Select Image Preview
      </button>
      <p>
        <b style="font-size: 12px; color: red"
          >Preview images: Your product images can be any size up to 5760 x 5760
          px, or 20 megapixels</b
        >
      </p>
      <p>
        <b style="font-size: 16px; color: red">{{ informText }}</b>
      </p>
      <div>
        <v-row>
          <v-col cols="12" v-if="preview_imgs == ''"
            ><b>No Image Available</b></v-col
          >
          <v-col cols="12" v-if="imagePreview.length > 0"
            >{{ imagePreview.length }} files selected</v-col
          >

          <template v-for="(i, index) in preview_imgs">
            <v-col cols="12" :key="i._id" v-if="index == 0">
              <img v-bind:src="i.img_url" style="height: 300px" /><br />
              <v-row>
                <v-col cols="2">
                  <button
                    class="btn btn-sm btn-danger"
                    @click="removeImage(i.img_id, index)"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </v-col>
                <v-col cols="9">
                  <input
                    type="number"
                    class="form-control"
                    placeholder="position..."
                    v-model="i.img_pos"
                    @change="changeImgPosition"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="3" :key="i._id" v-else>
              <img v-bind:src="i.img_url" style="height: 70px" /><br />
              <v-row>
                <v-col cols="2">
                  <button
                    class="btn btn-sm btn-danger"
                    @click="removeImage(i.img_id, index)"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </v-col>
                <v-col cols="9">
                  <input
                    type="number"
                    class="form-control"
                    placeholder="position..."
                    v-model="i.img_pos"
                    @change="changeImgPosition"
                  />
                </v-col>
              </v-row>
            </v-col>
          </template>

          <v-col cols="12" class="border" v-if="imagePreview.length > 0"
            >Preview Image
            <v-row>
              <v-col cols="2" v-for="i in imagePreview" :key="i.image">
                <img v-bind:src="i.image" style="height: 70px" /><br />
                <v-row>
                  <v-col cols="12">
                    <input
                      type="number"
                      class="form-control"
                      placeholder="position..."
                      v-model="i.pos"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- <p v-if="!informPreview"><b style="font-size: 14px;color:red;">Image position uniqueness, integer and greater than 0</b></p> -->
        <v-alert type="error" v-if="!informPreview">
          Image position uniqueness, integer and greater than 0
        </v-alert>

        <button
          v-if="imagePreview.length > 0 && loadingPreview"
          @click="uploadImagePreview"
          class="btn btn-sm btn-success"
        >
          Upload image
        </button>
        <!-- <button v-if="imagePreview.length > 0" @click="checkImg" class="btn btn-sm btn-success">Check</button>  -->
      </div>
    </v-col>

    <template v-else>
      <img v-bind:src="require('../../assets/loading/loading.gif')" />
    </template>
  </div>
</template>

<script>
import axios from "axios";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

const API_ENDPOINT = window.domain + "products/upload-image";
const API_ENDPOINT_DEL = window.domain + "products/delete-image";
const MAX_IMAGE_SIZE = 6300000;

export default {
  name: "image-preview",
  props: ["product_id"],
  data: () => ({
    AuthStr: "",
    imageDesign: [],
    imagePreview: [],
    imageTemp: [],
    imageFormat: "",
    uploadURL: "",
    loadingDesign: true,
    loadingPreview: true,
    preview_imgs: [],
    informPreview: true,
    productData: [],
    informText: "",
  }),

  created() {
    this.$root.$refs.imagePreview = this;
  },

  watch: {
    preview_imgs() {
      this.$root.$refs.seller.changeImgPosition(this.preview_imgs);
    },
  },

  methods: {
    async loadDataImagePreview() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "image-preview-loadDataImagePreview"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "products/" + this.$route.params.id, {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("image-preview-response: ", response);
            this.preview_imgs = response.data.data.product.preview_imgs;
            this.productData = response.data.data.product;

            var temp = 0;
            for (let i = 0; i < this.preview_imgs.length - 1; i++) {
              for (let j = 0; j < this.preview_imgs.length - 1 - i; j++) {
                if (
                  parseInt(this.preview_imgs[j].img_pos) >
                  parseInt(this.preview_imgs[j + 1].img_pos)
                ) {
                  temp = this.preview_imgs[j];
                  this.preview_imgs[j] = this.preview_imgs[j + 1];
                  this.preview_imgs[j + 1] = temp;
                }
              }
            }

            var id = 0;
            for (const k of this.preview_imgs) {
              id += 1;
              k["_id"] = id;
            }

            console.log(this.preview_imgs);
          });
      } else {
        console.log(
          "currentSession image-preview-loadDataImagePreview-undefined: ",
          currentSession
        );
      }
    },

    onFilePreviewChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      
      for(let i of files){
        this.createImage(i);
      }

      // files.forEach((element) => {
      //   this.createImage(element);
      // });
    },

    cancelImagePreview() {
      this.imagePreview = [];
    },

    createImage(file) {
      this.informText = "";
      let reader = new FileReader();
      reader.onload = (e) => {
        if (e.target.result.includes("data:image/jpeg")) {
          this.imageFormat = "image/jpeg";
        } else if (e.target.result.includes("data:image/png")) {
          this.imageFormat = "image/png";
        } else if (e.target.result.includes("data:image/bmp")) {
          this.imageFormat = "image/bmp";
        } else {
          return (this.informText = "Wrong file type - JPG/PNG/BMP only.");
        }

        console.log("e.target.result.length: ", e.target.result.length);
        if (e.target.result.length > MAX_IMAGE_SIZE) {
          return (this.informText = "Image is loo large - 4.7MB maximum");
        }

        var image = {
          image: e.target.result,
          format: this.imageFormat,
          pos: "",
        };

        this.imagePreview.push(image);
      };
      reader.readAsDataURL(file);
      //this.uploadImage()
    },

    checkImg() {
      console.log(this.imagePreview);
    },

    async removeImage(imageid, index) {
      this.loadingPreview = false;
      var currentSession = await this.$root.$refs.App.currentSession(
        "image-preview-removeImage"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        const uploadResponse = await axios({
          method: "POST",
          url: API_ENDPOINT_DEL,
          headers: { Authorization: currentSession.accessToken },
          data: {
            image_id: imageid,
            image_folder: "product-preview",
            product_id: this.$route.params.id,
          },
        });
        console.log("removeImage: ", uploadResponse);

        this.preview_imgs.splice(index, 1);
        this.loadingPreview = true;
      } else {
        console.log(
          "currentSession image-preview-removeImage-undefined: ",
          currentSession
        );
      }
    },

    async uploadImagePreview() {
      this.informPreview = true;
      this.loadingPreview = false;
      var tempArr = [];

      for (const item of this.imagePreview) {
        tempArr.push(item.pos);
      }

      for (const item2 of this.preview_imgs) {
        tempArr.push(item2.img_pos.toString());
      }

      let findDuplicates = (arr) =>
        arr.filter((item, index) => arr.indexOf(item) != index);

      function isInt(n) {
        return n % 1 === 0;
      }

      var tempInt = true;
      for (const item of this.imagePreview) {
        if (isInt(item.pos) == false) {
          tempInt = false;
          break;
        }
      }

      var greaterThan0 = true;
      for (const item of this.imagePreview) {
        if (item.pos <= 0) {
          greaterThan0 = false;
          break;
        }
      }

      if (
        findDuplicates(tempArr).length == 0 &&
        tempInt == true &&
        greaterThan0 == true
      ) {
        let axiosArray = [];
        var currentSession = await this.$root.$refs.App.currentSession(
          "image-preview-uploadImagePreview"
        );
        //console.log('currentSession: ',currentSession.accessToken)
        if (currentSession.accessToken) {
          for (let x = 0; x < this.imagePreview.length; x++) {
            let postData = {};
            var base64EncodedStr = this.imagePreview[x].image.split(",")[1];
            postData["image_base64"] = base64EncodedStr;
            (postData["image_folder"] = "product-preview"),
              (postData["image_format"] = this.imagePreview[x].format);
            (postData["product_id"] = this.$route.params.id),
              (postData["designer_id"] = currentSession.username);
            postData["img_pos"] = this.imagePreview[x].pos;
            let newPromise = axios({
              method: "post",
              url: API_ENDPOINT,
              headers: { Authorization: currentSession.accessToken },
              data: postData,
            });
            axiosArray.push(newPromise);
          }
        } else {
          console.log(
            "currentSession image-preview-uploadImagePreview: ",
            currentSession
          );
        }

        let all = await axios.all(axiosArray).catch((error) => {
          console.log(error);
        });

        console.log(all);

        for (const i of all) {
          var item = {
            img_id: i.data.data.image_id,
            img_url: i.data.data.image_url,
            img_pos: i.data.data.image_pos,
          };
          this.preview_imgs.push(item);
        }
        this.imagePreview = [];
        this.loadingPreview = true;
        this.informPreview = true;
      } else {
        this.informPreview = false;
        this.loadingPreview = true;
      }
    },

    changeImgPosition() {
      this.informText = "";
      var tempArr = [];
      var checkEmpty = false;
      var greaterThan0 = true;

      for (const item of this.imagePreview) {
        tempArr.push(item.pos);
      }

      for (const item2 of this.preview_imgs) {
        tempArr.push(item2.img_pos.toString());
      }
      console.log("tempArr: ", tempArr);

      for (const item of tempArr) {
        if (parseInt(item) <= 0) {
          greaterThan0 = false;
          break;
        }
      }
      console.log("greaterThan0: ", greaterThan0);

      let findDuplicates = (arr) =>
        arr.filter((item, index) => arr.indexOf(item) != index);

      for (const i of tempArr) {
        if (i == "") {
          checkEmpty = true;
          break;
        } else {
          checkEmpty = false;
        }
      }

      if (
        findDuplicates(tempArr).length == 0 &&
        checkEmpty == false &&
        greaterThan0 == true
      ) {
        for (const i of this.preview_imgs) {
          i.img_pos = parseInt(i.img_pos);
        }
        this.$root.$refs.seller.changeImgPosition(this.preview_imgs);
      } else {
        this.informText =
          "Cannot set DUPLICATE or EMPTY or SMALLER THAN 1 for Preview Image position.";
        this.$root.$refs.seller.changeImgPosition("");
      }
    },
  },
  async mounted() {
    // var currentSession;
    // try{
    // currentSession = await Auth.currentSession(); // Auth.currentSession() will automatically refresh the accessToken and idToken if tokens are expired
    // console.log("image-preview-currentSession: ",currentSession)
    // }catch(error){
    // console.log("image-preview-error: ",error)
    // }
    // if(currentSession != undefined){
    //     let accessToken = currentSession.accessToken.jwtToken;
    //     this.AuthStr = 'Bearer '.concat(accessToken);
    //     this.loadDataImagePreview()
    // }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      this.loadDataImagePreview();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
</style>